/* Pulsara theme — vanilla JS, no dependencies */
(function () {
  'use strict';
  var PZ = window.PZ = window.PZ || {};
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- money ---------- */
  PZ.money = function (cents) {
    var fmt = PZ.moneyFormat || '${{amount}}';
    cents = parseInt(cents || 0, 10);
    function group(n, dec, th, sep) {
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts[0] + (parts[1] ? sep + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      switch (k) {
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(cents, 2, "'", '.');
        default: return group(cents, 2, ',', '.');
      }
    });
  };
  PZ.moneyShort = function (cents) {
    var s = PZ.money(cents);
    return (cents % 100 === 0) ? s.replace(/[.,]00(?=\D*$)/, '') : s;
  };

  PZ.handle = function (str) {
    return String(str || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  };

  /* ---------- drawers ---------- */
  var overlay;
  function openDrawer(el) {
    if (!el) return;
    closeAll();
    overlay = overlay || document.querySelector('[data-pz-overlay]');
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('pz-lock');
    var f = el.querySelector('button, a');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 50);
  }
  function closeAll() {
    document.querySelectorAll('.pz-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    overlay = overlay || document.querySelector('[data-pz-overlay]');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('pz-lock');
  }
  PZ.openCart = function () { openDrawer(document.querySelector('[data-pz-cart-drawer]')); PZ.refreshCart(); };
  PZ.closeDrawers = closeAll;
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pz-open-cart]');
    if (t && document.querySelector('[data-pz-cart-drawer]')) { e.preventDefault(); PZ.openCart(); return; }
    if (e.target.closest('[data-pz-open-menu]')) { e.preventDefault(); openDrawer(document.querySelector('[data-pz-menu-drawer]')); return; }
    if (e.target.closest('[data-pz-close]') || e.target.matches('[data-pz-overlay]')) { e.preventDefault(); closeAll(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- cart ---------- */
  var productCache = {};
  function getProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (!productCache[handle]) {
      productCache[handle] = fetch(root + 'products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    return productCache[handle];
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  function setCount(n) {
    document.querySelectorAll('[data-pz-cart-count]').forEach(function (el) { el.textContent = n; });
    document.querySelectorAll('[data-pz-cart-badge]').forEach(function (el) { el.textContent = n; el.classList.toggle('is-visible', n > 0); });
  }

  PZ.renderCart = function (cart) {
    setCount(cart.item_count);
    var box = document.querySelector('[data-pz-cart-items]');
    var foot = document.querySelector('[data-pz-cart-foot]');
    if (!box) return;
    var empty = document.querySelector('[data-pz-cart-empty]');
    if (!cart.items.length) {
      box.innerHTML = '';
      if (empty) empty.hidden = false;
      if (foot) foot.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    var meta = box.getAttribute('data-meta') || '';
    Promise.all(cart.items.map(function (it) { return getProduct(it.handle); })).then(function (products) {
      var compareTotal = 0;
      box.innerHTML = cart.items.map(function (it, i) {
        var p = products[i], cmp = 0;
        if (p) { (p.variants || []).forEach(function (v) { if (v.id === it.variant_id && v.compare_at_price > v.price) cmp = v.compare_at_price * it.quantity; }); }
        compareTotal += cmp || it.final_line_price;
        var name = it.product_title + (it.variant_title && it.variant_title !== 'Default Title' ? ' — ' + it.variant_title : '');
        var img = it.image || '';
        if (p && it.options_with_values && it.options_with_values[0]) {
          var slug = PZ.handle(it.options_with_values[0].value);
          (p.media || []).some(function (m) {
            var src = (m.src || (m.preview_image && m.preview_image.src) || '');
            var alt = m.alt || '';
            var key = alt.indexOf('|') > -1 ? PZ.handle(alt.split('|')[0]) : '';
            var fname = src.split('?')[0].split('/').pop().toLowerCase();
            if (key === slug || (!key && fname.indexOf(slug + '-') === 0 && fname.indexOf(slug + '-end') !== 0)) { img = src; return true; }
            return false;
          });
        }
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=200';
        return '<div class="pz-line">' +
          '<a class="pz-line__img" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(name) + '" loading="lazy">' : '') + '</a>' +
          '<div class="pz-line__body"><div class="pz-line__top"><a class="pz-line__name" href="' + esc(it.url) + '">' + esc(name) + '</a>' +
          '<span class="pz-line__price">' + (cmp ? '<s>' + PZ.moneyShort(cmp) + '</s>' : '') + '<span>' + PZ.moneyShort(it.final_line_price) + '</span></span></div>' +
          (meta ? '<span class="pz-line__meta">' + esc(meta) + '</span>' : '') +
          '<div class="pz-line__actions"><div class="pz-qty"><button type="button" class="pz-icon-btn" data-pz-qty="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease quantity">–</button><span>' + it.quantity + '</span><button type="button" class="pz-icon-btn" data-pz-qty="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
          '<button type="button" class="pz-remove" data-pz-qty="' + esc(it.key) + '" data-q="0">Remove</button></div></div></div>';
      }).join('');
      if (foot) {
        foot.hidden = false;
        var sub = foot.querySelector('[data-pz-cart-subtotal]');
        if (sub) sub.textContent = PZ.moneyShort(cart.total_price);
        var save = foot.querySelector('[data-pz-cart-save]');
        if (save) {
          var diff = compareTotal - cart.total_price;
          var tpl = save.getAttribute('data-template') || '';
          if (diff > 0 && tpl) {
            var pct = Math.round(diff / compareTotal * 100);
            save.textContent = tpl.replace('[amount]', PZ.moneyShort(diff)).replace('[percent]', pct);
            save.hidden = false;
          } else {
            var none = save.getAttribute('data-none') || '';
            save.textContent = none; save.hidden = !none;
          }
        }
      }
    });
  };
  PZ.refreshCart = function () {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { PZ.renderCart(c); return c; });
  };
  PZ.addToCart = function (id, qty, btn) {
    if (btn) btn.setAttribute('aria-busy', 'true');
    return fetch(root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        if (document.querySelector('[data-pz-cart-drawer]')) { PZ.openCart(); } else { window.location.href = root + 'cart'; }
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Could not add to cart.';
        var holder = btn && btn.closest('[data-pz-product], .pz-card');
        var box = holder && holder.querySelector('[data-pz-error]');
        if (box) { box.textContent = msg; box.hidden = false; } else { alert(msg); }
      })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  };
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-pz-qty]');
    if (q) {
      e.preventDefault();
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: q.getAttribute('data-pz-qty'), quantity: Math.max(0, parseInt(q.getAttribute('data-q'), 10)) }) })
        .then(function (r) { return r.json(); }).then(PZ.renderCart);
      return;
    }
    var a = e.target.closest('[data-pz-add]');
    if (a) { e.preventDefault(); PZ.addToCart(a.getAttribute('data-pz-add'), 1, a); }
  });

  /* ---------- accordions ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pz-acc-btn]');
    if (!b) return;
    var item = b.closest('.pz-acc__item');
    var group = b.closest('[data-pz-acc]');
    var panel = item && item.querySelector('.pz-acc__panel');
    var open = b.getAttribute('aria-expanded') === 'true';
    if (group && group.hasAttribute('data-single') && !open) {
      group.querySelectorAll('[data-pz-acc-btn][aria-expanded="true"]').forEach(function (o) {
        o.setAttribute('aria-expanded', 'false');
        var s = o.querySelector('.pz-acc__sign'); if (s) s.textContent = '+';
        var p = o.closest('.pz-acc__item').querySelector('.pz-acc__panel'); if (p) p.hidden = true;
      });
    }
    b.setAttribute('aria-expanded', open ? 'false' : 'true');
    var sign = b.querySelector('.pz-acc__sign'); if (sign) sign.textContent = open ? '+' : '–';
    if (panel) panel.hidden = open;
  });

  /* ---------- legal tabs ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-pz-tab]');
    if (!t) return;
    var wrap = t.closest('[data-pz-tabs]');
    wrap.querySelectorAll('[data-pz-tab]').forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
    wrap.querySelectorAll('[data-pz-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-pz-panel') !== t.getAttribute('data-pz-tab'); });
  });

  /* ---------- gallery ---------- */
  function Gallery(el) {
    this.el = el;
    this.stage = el.querySelector('.pz-gallery__stage');
    this.track = el.querySelector('.pz-gallery__track');
    this.thumbs = el.querySelector('.pz-thumbs');
    this.i = 0;
    this.slides = [];
    var self = this;
    el.querySelector('.pz-arrow--prev') && el.querySelector('.pz-arrow--prev').addEventListener('click', function () { self.go(self.i - 1, true); });
    el.querySelector('.pz-arrow--next') && el.querySelector('.pz-arrow--next').addEventListener('click', function () { self.go(self.i + 1, true); });
    this.bindDrag();
    this.filter(el.getAttribute('data-initial-key') || '');
  }
  Gallery.prototype.filter = function (key) {
    key = String(key || '');
    var all = Array.prototype.slice.call(this.track.querySelectorAll('.pz-slide'));
    var mine = all.filter(function (s) { return s.getAttribute('data-key') === key; });
    var shared = all.filter(function (s) { return s.getAttribute('data-key') === 'shared'; });
    var end = all.filter(function (s) { return s.getAttribute('data-key') === key + '-end'; });
    var keyed = all.some(function (s) { var k = s.getAttribute('data-key'); return k && k !== 'shared'; });
    var list = all;
    if (keyed && (mine.length || end.length)) {
      list = [];
      for (var n = 0; n < Math.max(mine.length, shared.length); n++) {
        if (mine[n]) list.push(mine[n]);
        if (shared[n]) list.push(shared[n]);
      }
      list = list.concat(end);
    }
    var track = this.track;
    all.forEach(function (s) { s.hidden = list.indexOf(s) < 0; });
    list.forEach(function (s) { track.appendChild(s); });
    this.slides = list;
    this.i = 0;
    this.render(false);
  };
  Gallery.prototype.go = function (i, wrap) {
    var n = this.slides.length;
    if (!n) return;
    if (wrap) i = (i + n) % n; else i = Math.max(0, Math.min(n - 1, i));
    this.i = i;
    this.render(true);
  };
  Gallery.prototype.render = function (animate) {
    var n = this.slides.length, self = this;
    if (!animate) this.track.style.transition = 'none';
    this.track.style.transform = 'translate3d(' + (-100 * this.i) + '%, 0, 0)';
    if (!animate) { this.track.offsetHeight; this.track.style.transition = ''; }
    if (!this.thumbs) return;
    var start = Math.min(Math.max(this.i - 2, 0), Math.max(0, n - 5));
    var html = '';
    for (var k = start; k < Math.min(n, start + 5); k++) {
      var img = this.slides[k].querySelector('img');
      var src = img ? (img.getAttribute('data-thumb') || img.currentSrc || img.src) : '';
      html += '<button type="button" class="pz-thumb" data-i="' + k + '" aria-pressed="' + (k === this.i) + '" aria-label="' + esc(img ? img.alt : 'Image ' + (k + 1)) + '">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : '') + '</button>';
    }
    this.thumbs.innerHTML = html;
    this.thumbs.querySelectorAll('.pz-thumb').forEach(function (b) { b.addEventListener('click', function () { self.go(parseInt(b.getAttribute('data-i'), 10)); }); });
    this.el.classList.toggle('is-single', n < 2);
  };
  Gallery.prototype.bindDrag = function () {
    var self = this, sx = null, sy = 0, dx = 0, w = 1;
    var st = this.stage;
    st.addEventListener('pointerdown', function (e) {
      if (e.target.closest('button') || (e.pointerType === 'mouse' && e.button !== 0)) return;
      sx = e.clientX; sy = e.clientY; dx = 0; w = st.clientWidth || 1;
      try { st.setPointerCapture(e.pointerId); } catch (err) {}
      st.classList.add('is-dragging');
    });
    st.addEventListener('pointermove', function (e) {
      if (sx == null) return;
      dx = e.clientX - sx;
      var n = self.slides.length;
      var edge = (self.i === 0 && dx > 0) || (self.i === n - 1 && dx < 0);
      var shown = edge ? dx * 0.35 : dx;
      self.track.style.transform = 'translate3d(calc(' + (-100 * self.i) + '% + ' + shown + 'px), 0, 0)';
    });
    function end() {
      if (sx == null) return;
      sx = null; st.classList.remove('is-dragging');
      var n = self.slides.length, next = self.i;
      if (dx <= -w * 0.18 && self.i < n - 1) next = self.i + 1;
      else if (dx >= w * 0.18 && self.i > 0) next = self.i - 1;
      self.i = next; self.render(true);
    }
    st.addEventListener('pointerup', end);
    st.addEventListener('pointercancel', end);
    st.addEventListener('lostpointercapture', end);
    st.addEventListener('dragstart', function (e) { e.preventDefault(); });
  };

  /* ---------- product form ---------- */
  function Product(el) {
    var dataEl = el.querySelector('[data-pz-product-json]');
    if (!dataEl) return;
    this.el = el;
    this.data = JSON.parse(dataEl.textContent);
    this.swatchInfo = {};
    var infoEl = el.querySelector('[data-pz-swatch-json]');
    if (infoEl) this.swatchInfo = JSON.parse(infoEl.textContent);
    this.gallery = el.querySelector('[data-pz-gallery]') ? new Gallery(el.querySelector('[data-pz-gallery]')) : null;
    this.options = this.data.current.options.slice();
    var self = this;
    el.querySelectorAll('[data-pz-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        self.options[parseInt(b.getAttribute('data-pz-opt'), 10)] = b.getAttribute('data-value');
        self.update(true);
      });
    });
    var add = el.querySelector('[data-pz-add-current]');
    if (add) add.addEventListener('click', function (e) {
      e.preventDefault();
      var id = el.querySelector('[name="id"]').value;
      var err = el.querySelector('[data-pz-error]'); if (err) err.hidden = true;
      PZ.addToCart(id, 1, add);
    });
  }
  Product.prototype.update = function (fromClick) {
    var self = this, opts = this.options;
    var v = this.data.variants.filter(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); })[0];
    this.el.querySelectorAll('[data-pz-opt]').forEach(function (b) {
      var i = parseInt(b.getAttribute('data-pz-opt'), 10);
      b.setAttribute('aria-pressed', b.getAttribute('data-value') === opts[i] ? 'true' : 'false');
    });
    var first = opts[0] || '';
    var keyBtn = this.el.querySelector('[data-pz-opt="0"][aria-pressed="true"]');
    var firstKey = (keyBtn && keyBtn.getAttribute('data-key')) || PZ.handle(first);
    var info = this.swatchInfo[firstKey] || {};
    this.el.querySelectorAll('[data-pz-opt-label]').forEach(function (n) { var i = parseInt(n.getAttribute('data-pz-opt-label'), 10); n.textContent = opts[i]; });
    this.el.querySelectorAll('[data-pz-finish-name]').forEach(function (n) { n.textContent = first; });
    var note = this.el.querySelector('[data-pz-finish-note]'); if (note) { note.textContent = info.note || ''; note.hidden = !info.note; }
    var spec = this.el.querySelector('[data-pz-finish-spec]'); if (spec) { spec.textContent = first + (info.spec ? ' — ' + info.spec : ''); }
    var btn = this.el.querySelector('[data-pz-add-current]');
    var label = btn && btn.querySelector('[data-pz-btn-label]');
    if (!v) {
      if (btn) btn.disabled = true;
      if (label) label.textContent = btn.getAttribute('data-unavailable');
      return;
    }
    this.el.querySelector('[name="id"]').value = v.id;
    var now = this.el.querySelector('[data-pz-price]'); if (now) now.textContent = PZ.moneyShort(v.price);
    var was = this.el.querySelector('[data-pz-compare]');
    var badge = this.el.querySelector('[data-pz-badge]');
    var onSale = v.compare_at_price && v.compare_at_price > v.price;
    if (was) { was.textContent = onSale ? PZ.moneyShort(v.compare_at_price) : ''; was.hidden = !onSale; }
    if (badge) {
      badge.hidden = !onSale;
      if (onSale) badge.textContent = (badge.getAttribute('data-template') || 'SALE −[percent]%').replace('[percent]', Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100));
    }
    if (btn) {
      btn.disabled = !v.available;
      if (label) label.textContent = v.available ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
    }
    if (this.gallery && fromClick) this.gallery.filter(firstKey);
    if (fromClick && window.history && history.replaceState) {
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
    }
  };

  function init() {
    PZ.moneyFormat = window.PZ_MONEY_FORMAT || PZ.moneyFormat;
    document.querySelectorAll('[data-pz-product]').forEach(function (el) { if (!el.__pz) { el.__pz = new Product(el); } });
    document.querySelectorAll('[data-pz-gallery-standalone]').forEach(function (el) { if (!el.__pz) el.__pz = new Gallery(el); });
    if (document.querySelector('[data-pz-cart-drawer]')) PZ.refreshCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
